import { SelectField } from '@hologram-dimension/select-field';
import { TextInput } from '@hologram-dimension/text-input';
import { type FC, type KeyboardEvent, useCallback } from 'react';
import useSimInventoryStoredFilters from 'state/SimInventory/useSimInventoryStoredFilters';
import { filterLabels } from 'components/SimInventoryFilters/shared';
import FilterAccordion, { type FilterProps } from '../../FilterAccordion/FilterAccordion';
import filterStyles from '../filterStyles.module.css';

const IMEIFilter: FC<FilterProps> = ({ form, onClear, submit }) => {
  const { register, getValues } = form;
  const storedFilters = useSimInventoryStoredFilters();
  const storedImei = storedFilters?.imei?.value;

  const imeiField = register('imei.value', {
    onBlur: () => {
      submit();
    },
  });

  const { value: imei } = getValues('imei') ?? {};

  const handleConditionChange = useCallback(() => {
    if (imei && imei.length > 0) {
      submit();
    }
  }, [imei, submit]);

  const imeiCondition = register('imei.condition', {
    onChange: handleConditionChange,
  });

  const onKeyUp = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter') {
        submit();
      }
    },
    [submit]
  );

  return (
    <FilterAccordion
      onClear={onClear}
      label={filterLabels.imei}
      isSet={storedImei !== undefined}
      defaultActive={storedImei !== undefined}
    >
      <div className={filterStyles.defaultWrapper}>
        <SelectField
          label=""
          id="imeiCondition"
          options={[
            { label: 'Is', value: 'is' },
            { label: 'Starts With', value: 'startswith' },
            { label: 'Ends With', value: 'endswith' },
            { label: 'Contains', value: 'contains' },
          ]}
          {...imeiCondition}
        />
        <TextInput
          id="imei"
          onKeyUp={onKeyUp}
          inputProps={{ 'data-1p-ignore': true, 'data-lpignore': true } as any}
          {...imeiField}
        />
      </div>
    </FilterAccordion>
  );
};

export default IMEIFilter;
